import script from "./RequirementsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./RequirementsPopup.vue?vue&type=script&setup=true&lang=js"

import "./RequirementsPopup.vue?vue&type=style&index=0&id=ab137224&scoped=true&lang=scss"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab137224"]])

export default __exports__